import Box from '@spotnana/pixel-react/dist/Box';
import styled from 'styled-components';

export const HardApprovalContainer = styled(Box)`
  margin-top: 16px;
`;
